




































import {Vue, Component} from 'vue-property-decorator';
import ContentBottom from './ContentBottom.vue';
import {AccumulationsObj} from '@/types';
import ItemTable from '@/components/common/ItemTable.vue';
import {ncpPopup} from '@/utils/ncp';
import {i18nInObjectList} from '@/utils/i18n';
import {addClass, removeClass} from '@/utils/classUtils';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';
import {GetAccumulationsDailyRequest} from 'supporter';
import {getToday} from '@/utils/dateUtils';

@Component({
  components: {
    ContentBottom,
    ItemTable,
    ExcelCreateButton
  }
})
export default class AccumulationPopup extends Vue {
  private listContent: any = [];
  private totalCount: any = 0;
  private contentBottomOption: any = {
    haveConfigBtn: true,
    haveExcelDownBtn: false,
    excelDownInfo: {
      columns: {
        mallName: 'ACCUMULATION_MAIN_BOTTOM_TABLE_HEADER_ONE',
        date: 'ACCUMULATION_MAIN_DATE',
        status: 'ACCUMULATION_MAIN_STATUS',
        detailReason: 'ACCUMULATION_MAIN_DETAIL_RESEAN',
        giveAccumulationAmt: 'ACCUMULATION_MAIN_GIVE',
        subtractionAccumulationAmt: 'ACCUMULATION_MAIN_SUBSTRUC',
        memberNo: 'ACCUMULATION_MAIN_MEMBER_NO',
        registerAdminName: 'ACCUMULATION_MAIN_REGISTER_ADMIN_NAME'
      },
      fileName: 'daily_point_',
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {
        status: (data: any): any => {
          let name: any = '';
          if (data.value === 'GIVE') {
            name = `${window.$t('ACCUMULATION_MAIN_GIVE')}`;
          } else if (data.value === 'SUBTRACTION') {
            name = `${window.$t('ACCUMULATION_MAIN_SUBSTRUC')}`;
          }
          return name;
        }
      }
    }
  };
  private mallName: any = '';
  private date = '';
  private accumulateAmount: any = '';
  private deductionAmount: any = '';
  private accumulationsArr: AccumulationsObj[] = [];
  private size: number = 30;

  private excelRequest: GetAccumulationsDailyRequest | null = {
    params: {
      page: 1,
      pageSize: 30,
      mallNo: null,
      startDateTime: getToday() + '00:00:00',
      endDateTime: getToday() + '23:59:59',
    }
  };

  private created(): void {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
  private beforeMount(): void {
    this.mallName = this.$route.query.mallName;
    this.date = this.$route.query.date as string;
    this.accumulateAmount = Number(this.$route.query.accumulateAmount);
    this.deductionAmount = Number(this.$route.query.deductionAmount);
  }
  private mounted(): void {
    $('body').on('click', '.accumulationPop', $.proxy(this.openPop, this));
    addClass(document.body, 'popup');
  }
  private destroyed(): void {
    $('body').off('click', '.accumulationPop', $.proxy(this.openPop, this));
    removeClass(document.body, 'popup');
  }
  private openPop(e: any): void {
    const memberno = $(e.target).data('memberno');
    const title: any = this.$t('ACCUMULATION_MAIN_POP_TITLE');
    ncpPopup(`/member/popup/crm/${memberno}`, title, 950, 700);
  }
  private formatterContent(arr: any): any {
    if (arr.length === 0) {
      return;
    }
    arr.map((item: any): any => {
      this.$set(item, 'mallName', this.$route.query.mallName);
      this.$set(item, 'date', this.$route.query.date);
      let theAmount: any = item.amount.toLocaleString();
      if (item.status === 'GIVE' || item.status === 'GIVE_BY_CANCELED') {
        this.$set(item, 'giveAccumulationAmt', theAmount);
        this.$set(item, 'subtractionAccumulationAmt', '0');
      } else if (item.status === 'SUBTRACTION') {
        this.$set(item, 'giveAccumulationAmt', '0');
        this.$set(item, 'subtractionAccumulationAmt', theAmount);
      }
    });
  }
  private search(page: number = 1, size?: number): void {
    if (size) {
      this.size = size;
    }

    let request: any = {
      params: {
        mallNo: this.$route.query.mallNo,
        startDateTime: this.$route.query.date + ' 00:00:00',
        endDateTime: this.$route.query.date + ' 23:59:59'
      }
    };
    request.params.page = page;
    request.params.periodType = 'REGISTER';
    request.params.pageSize = this.size;

    this.$api.getAccumulations(request).then((res: any) => {
      this.listContent = [];
      this.listContent = res.data.contents;
      this.formatterContent(this.listContent);

      this.totalCount = res.data.totalCount;
      this.gridProps.options.pageOptions.page = page;
      this.gridProps.options.pageOptions.perPage = this.size;
      this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
    });

    this.excelRequest = {...request}
  }

  private gridProps = {
    options: {
      pageOptions: {
        perPage: 1,
        page: 1,
        totalCount: 10
      }
    },
    myTheme: {
      name: 'myTheme',
      value: {
        cell: {
          header: {
            background: '#e5e5e5'
          },
          normal: {
            showVerticalBorder: true
          }
        }
      }
    },
    minRowHeight: 31,
    rowHeight: 31,
    bodyHeight: 190,
    isInitialRequest: true,
    useClientSort: false,
    scrollY: false,
    copyOptions: {
      useFormattedValue: true
    },
    columns: [
      {
        header: 'ACCUMULATION_MAIN_BOTTOM_TABLE_HEADER_ONE',
        name: 'mallName',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'ACCUMULATION_MAIN_MEMBER_NO',
        name: 'memberNo',
        align: 'center',
        minWidth: 85,
        formatter: (data: any) => {
          return `<a href="javascript:;" data-memberno=${data.value} class="view accumulationPop">${data.value}</a>`;
        }
      },
      {
        header: 'ACCUMULATION_MAIN_REGISTER_ADMIN_NAME',
        name: 'registerAdminName',
        align: 'center',
        minWidth: 85
      },
      {
        header: 'ACCUMULATION_MAIN_STATUS',
        name: 'status',
        align: 'center',
        minWidth: 85,
        formatter: (data: any): any => {
          let name: any = '';
          if (data.value === 'GIVE' || data.value === 'GIVE_BY_CANCELED') {
            name = `${window.$t('ACCUMULATION_MAIN_GIVE')}`;
          } else if (data.value === 'SUBTRACTION') {
            name = `${window.$t('ACCUMULATION_MAIN_SUBSTRUC')}`;
          }
          return name;
        }
      },
      {
        header: 'ACCUMULATION_MAIN_DETAIL_RESEAN',
        name: 'detailReason',
        align: 'center',
        minWidth: 85
      },
      {
        header: 'ACCUMULATION_MAIN_GIVE',
        name: 'giveAccumulationAmt',
        align: 'center',
        minWidth: 85
      },
      {
        header: '	ACCUMULATION_MAIN_SUBSTRUC',
        name: 'subtractionAccumulationAmt',
        align: 'center',
        minWidth: 85
      }
    ]
  };
}
